import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Typography,
} from "@mui/material"
import React, { useState } from "react"
import { CSVLink } from "react-csv"

import AddBulkMember from "./addBulkMember.jsx"
import AddSingleUser from "./addSingleMember.jsx"
import CSVUploader from "../../Component/csvUploader.jsx"
import useBreakPoints from "../../Hooks/useBreakPoints.js"
import FullTextSearch from "../../Component/fullTextSearch.jsx"

function AddMembers({ open, setOpen, refetch }) {
    const [file, setFile] = useState(null)
    const [search, setSearch] = useState(null)

    const { xs, md } = useBreakPoints()

    const handleClose = () => {
        setSearch(null)
        setFile(null)
        setOpen(false)
        refetch()
    }

    const handleCsv = (data) => {
        setFile(data)
    }

    const handleChange = (val) => setSearch(val)

    return (
        <Dialog
            fullScreen={xs && !md}
            maxWidth="md"
            onClose={handleClose}
            open={open}
            PaperProps={{
                sx: {
                    minWidth: md && "70ch",
                },
            }}
        >
            <DialogTitle
                sx={{
                    backgroundColor: "#FAFAFA",
                    py: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                        Add User
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ p: "1em" }}>
                    {!file && (
                        <Box sx={{ mb: "1em" }}>
                            <FullTextSearch onChange={handleChange} />
                        </Box>
                    )}
                    {search ? (
                        <AddSingleUser search={search} close={handleClose} />
                    ) : null}
                    {file && (
                        <AddBulkMember
                            file={file}
                            setFile={setFile}
                            close={handleClose}
                        />
                    )}
                    {!!search ||
                        (!file && (
                            <Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "1em",
                                    }}
                                >
                                    <CSVUploader onChange={handleCsv} />
                                    <Button
                                        sx={{
                                            textDecoration: "underline",
                                            textTransform: "none",
                                            color: "secondary.main",
                                            mt: "1em",
                                            px: "1em",
                                            width: 240,
                                            fontSize: 16,
                                        }}
                                    >
                                        <CSVLink
                                            data={[
                                                {
                                                    phone: "251910222324",
                                                    programs: "test program 1",
                                                },
                                                {
                                                    phone: "251985764312",
                                                    programs: "test program 2",
                                                },
                                            ]}
                                            style={{
                                                textDecoration: "inherit",
                                                color: "#000000",
                                            }}
                                            filename="trip users csv sample format.csv"
                                        >
                                            DownLoad Sample CSV
                                        </CSVLink>
                                    </Button>
                                </Box>
                                <Divider sx={{ my: "1em" }} />
                            </Box>
                        ))}
                </Box>
            </DialogContent>
            <DialogActions
                sx={{
                    px: 4,
                    py: 2,
                    bgcolor: "#fafafa",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}
            >
                <Button
                    size="small"
                    variant="contained"
                    sx={{
                        ":hover": { bgcolor: "#e4e4e4" },
                        backgroundColor: "#e4e4e4",
                        textTransform: "none",
                        fontWeight: "bold",
                        color: "black",
                        width: 120,
                    }}
                    onClick={handleClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddMembers
